export const fpAuthColors = {
  fpDarkBlue: '#144296',
  fpBirdBlue: '#8195cb',
  fpLightBlue: '#a3bce3',
  fpAuthBG: '#edf2f9',
  fpAuthFormBG: 'white',
};
